import axios from 'axios';
import ServiceToken from "./ServicesAuth/ServiceToken";
import ServiceAuth from "./ServicesAuth/ServiceAuth";
/* eslint-disable no-extra-semi */
/**
 * Класс для работы с апи
 */
export default class ServiceApi {

    static isShareToken() {
        return window.serviceShare !== null && typeof(window.serviceShare) !== 'undefined';
    }

    /**
     * Конфигурация аxios
     * @static
     * @property {Object} free - конфигурация аxios для микросервисасервиса свободы
     * @property {Object} demo - конфигурация axios для микросервиса демо
     * @property {Object} catalog - конфигурация axios для микросервиса каталога
     * @property {Object} reconciliation - конфигурация axios для микросервиса сверок
     */
    static api() {
        let headers = {};
        if (this.isShareToken()) {
            headers = {
                'X-Auth-Token': window.serviceShare.shareProductToken,
                'X-Share-Token': window.serviceShare.shareToken
            }
        }
        else
            headers = {'X-Auth-Token': ServiceToken.productToken}
        return {
            apiMap: axios.create({
                baseURL: process.env.VUE_APP_API_MAP_HOST,
                headers: headers
            }),
            free: axios.create({
                baseURL: process.env.VUE_APP_FREE_BACKEND_HOST,
                headers: headers
            }),
            demo: axios.create({baseURL: process.env.VUE_APP_DEMO_BACKEND_HOST}),
            prod: axios.create({baseURL: process.env.VUE_APP_PROD_BACKEND_HOST}),
            base: axios.create({baseURL: 'https://map.oohdeskbase.ru'}),
            catalog: axios.create({baseURL: process.env.VUE_APP_CATALOG_BACKEND_HOST}),
            reconciliation: axios.create({baseURL: process.env.VUE_APP_RECONCILIATION_BACKEND_HOST}),
        };
    }

    /**
     * Гет-запрос
     * @static
     * @async
     * @param {String} microserviceName - название микросервиса (ключ объекта api)
     * @param {String} route - маршрут
     * @param {Object} params - параметры гет запроса
     * @param {Object} reqConfig - хедеры запроса
     * @returns {Object}
     */
    static async get(microserviceName = '', route = "", params = {}, reqConfig = {}) {
        const api = this.api();
        try {
            const response = await api[microserviceName].get(route, {params: {...params}}, reqConfig);
            return response;
        }
        catch(error) {
           return this.createError(microserviceName, error);
        }
    }

    /**
     * Пост-запрос
     * @static
     * @async
     * @param {String} microserviceName - название микросервиса (ключ объекта api)
     * @param {String} route - маршрут
     * @param {Object} postData - тело пост-запроса
     * @param {Object} reqConfig - хедеры запроса
     * @returns {Object}
     */
    static async post(microserviceName = '', route = "", postData = {}, reqConfig = {}) {
        const api = this.api();
        try {
            let response = await api[microserviceName].post(route, postData, reqConfig);
            return response;
        }
        catch(error) {
            return this.createError(microserviceName, error);
        }
    }

    /**
     * put-запрос
     * @static
     * @async
     * @param {String} microserviceName - название микросервиса (ключ объекта api)
     * @param {String} route - маршрут
     * @param {Object} data - тело пост-запроса
     * @param {Object} reqConfig - хедеры запроса
     * @returns {Object}
     */
    static async put(microserviceName = '', route = "", data = {}, reqConfig = {}) {
        const api = this.api();
        try {
            let response = await api[microserviceName].put(route, data, reqConfig);
            return response;
        }
        catch(error) {
            return this.createError(microserviceName, error);
        }
    }

    /**
     * delete-запрос
     * @static
     * @async
     * @param {String} microserviceName - название микросервиса (ключ объекта api)
     * @param {String} route - маршрут
     * @param {Object} reqConfig - хедеры запроса, data запроса
     * @returns {Object}
     */
    static async delete(microserviceName = '', route = "", reqConfig = {}) {
        const api = this.api();
        try {
            let response = await api[microserviceName].delete(route, reqConfig);
            return response;
        }
        catch(error) {
            return this.createError(microserviceName, error);
        }
    }

    /**
     * Обработать ошибку
     * @static
     * @async
     * @param {String} microserviceName - название микросервиса (ключ объекта api)
     * @param {Object} error - бъект ошибки
     */
    static async createError(microserviceName = '', error = {}) {
        console.log(error);
        if (microserviceName === 'free' || microserviceName === 'apiMap') {
            const {response = {}} = error;
            const {status = -1} = response;
            if (status === 401 && !this.isShareToken()) {
                await ServiceAuth.logout();
            }
            if (status === 401 && this.isShareToken()) {
                ServiceAuth.toRoute('PageShareAccessDenied');
            }

        }
        throw error;
    }

    static getErrorMessage(error = {}, errorMessageDefault = '') {
        const errorMessage = Object.values(error?.response?.data?.data ?? {}).flat().join(', ') ?? errorMessageDefault;

        return errorMessage;
    }
};
